import type { SynthesiseRecipe } from '../../../../src/commonTypes';

/** Human-facing title shared by Synthesise board cards and their detail modal. */
export const getSynthesiseOutputTitle = (
	recipe: SynthesiseRecipe | undefined,
	fallback = 'Synthesise output'
): string => {
	const task = recipe?.task?.trim();
	if (!task) return fallback;
	if (task !== 'Post') return task;
	const platform = recipe?.settings?.platform?.trim();
	return platform ? `${platform} Post` : 'Post';
};
